import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleKeyboardNavigation } from '../utils/accessibility';
import logger from '../utils/logger';

/**
 * Composant pour gérer les raccourcis clavier globaux
 */
const KeyboardShortcuts = ({ enabled = true }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event) => {
      // Ignorer si l'utilisateur est en train de taper dans un input/textarea
      if (
        event.target.tagName === 'INPUT' ||
        event.target.tagName === 'TEXTAREA' ||
        event.target.isContentEditable
      ) {
        return;
      }

      // Raccourcis avec Ctrl/Cmd
      if (event.ctrlKey || event.metaKey) {
        switch (event.key) {
          case 'k':
            // Ctrl+K ou Cmd+K : Recherche globale
            event.preventDefault();
            navigate('/search');
            logger.event('keyboard_shortcut', { shortcut: 'Ctrl+K', action: 'search' });
            break;
          case 'h':
            // Ctrl+H ou Cmd+H : Accueil
            event.preventDefault();
            navigate('/');
            logger.event('keyboard_shortcut', { shortcut: 'Ctrl+H', action: 'home' });
            break;
          default:
            break;
        }
        return;
      }

      // Raccourcis simples
      switch (event.key) {
        case '/':
          // / : Recherche
          event.preventDefault();
          navigate('/search');
          logger.event('keyboard_shortcut', { shortcut: '/', action: 'search' });
          break;
        case '?':
          // ? : Aide (à implémenter)
          event.preventDefault();
          // TODO: Ouvrir un modal d'aide
          logger.event('keyboard_shortcut', { shortcut: '?', action: 'help' });
          break;
        case 'Escape':
          // Escape : Retour ou fermer les modales
          // (géré par les composants individuels)
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, navigate]);

  return null; // Ce composant ne rend rien
};

export default KeyboardShortcuts;



